import { types } from 'mobx-state-tree';

import itemStatusTranslation from 'js/config/itemStatusTranslation';
import orderStatusTranslation from 'js/config/orderStatusTranslation';

export default types
  .model('ActivityItem', {
    date: types.string,
    activity_type: types.string,
    order_relation: types.maybe(types.string),
    order_status: types.maybe(types.string),
    order_uid: types.maybe(types.string),
    order_alias: types.maybe(types.string),
    item_status: types.maybe(types.string),
    item_alias: types.string,
    price: types.number,
    title: types.string,
    quantity: types.maybe(types.union(types.number, types.string)),
    checkout_url: types.maybe(types.string),
    image: types.maybe(types.string),
  })
  .views(self => ({
    get is_order() {
      return !!self.order_uid;
    },
    get human_order_status() {
      return self.order_status ? orderStatusTranslation[self.order_status] : null;
    },
    get human_item_status() {
      return self.item_status ? itemStatusTranslation[self.item_status] : null;
    },
  }));
